/** Truthful identifiers for OMNISYNIA's optional self-hosted speech engines.
 * A profile is a preference; a named model is only shown after synthesis.
 * No third-party speaker identity is inferred from the selected gender.
 */
export type NaturalVoiceProfile = "feminine" | "masculine";
export const VOICE_PREVIEW_ES = Object.freeze({
  feminine: "Hola, esta es una prueba de la voz femenina de OMNISYNIA. Estoy aquí para escucharte y ayudarte con naturalidad.",
  masculine: "Hola, esta es una prueba de la voz masculina de OMNISYNIA. Estoy aquí para conversar contigo y ayudarte cada día."
} as const);

export function verifiedLocalVoiceLabel(model: string, voice: string, profile: NaturalVoiceProfile): string {
  const normalizedVoice = voice.trim();
  if (model === "kokoro-82m-v1") {
    if (normalizedVoice === "ef_dora" && profile === "feminine") return "Dora · Kokoro 82M";
    if (normalizedVoice === "em_alex" && profile === "masculine") return "Alex · Kokoro 82M";
  }
  if (model === "supertonic3") {
    if (normalizedVoice === "F3" && profile === "feminine") return "F3 · Supertonic";
    if (normalizedVoice === "M1" && profile === "masculine") return "M1 · Supertonic";
  }
  if (model === "piper-es_ES-sharvard-medium") {
    if (normalizedVoice === "sharvard-F" && profile === "feminine") return "Femenina · Piper SHARVARD";
    if (normalizedVoice === "sharvard-M" && profile === "masculine") return "Masculina · Piper SHARVARD";
  }
  return (profile === "feminine" ? "Voz femenina local" : "Voz masculina local") +
    " · modelo sin identificar";
}
